<script>
import appConfig from "@/app.config";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";

/**
 * Maintenance component
 */
export default {
  page: {
    title: "Aprovação",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  created() {

    api.get(`${getBaseUrl()}api/projaprova`).then((res) => {

      console.log('then axios')
      console.log(res.data)

        // this.condpgtosList = res.data[0]
        // this.title = `(${this.condpgtosList.length}) Condições de Pagamento`
        // this.loadingList = false
        // this.loadingGraph = false

    })

  }
};
</script>
<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <router-link to="/">
        <i class="fas fa-home h2"></i>
      </router-link>
    </div>
    <section class="my-5 pt-sm-5">
      <b-container>
        <b-row>
          <div class="col-12 text-center">
            <div class="home-wrapper">
              <div class="mb-5">
                <router-link to="/" class="d-block auth-logo">
                  <img
                      src="@/assets/images/logo-dark.png"
                      alt=""
                      height="20"
                      class="auth-logo-dark mx-auto"
                  />
                  <img
                      src="@/assets/images/logo-light.png"
                      alt=""
                      height="20"
                      class="auth-logo-light mx-auto"
                  />
                </router-link>
              </div>

              <b-row class="justify-content-center">
                <div class="col-sm-4">
                  <div class="maintenance-img">
                    <img
                        src="@/assets/images/verification-img.png"
                        alt
                        class="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </b-row>
              <h3 class="mt-5">Última Apresentação (nome_arquivo)</h3>
              <p>Por favor verifique se está de acordo.</p>

              <b-row >

                <div class="col-md-4">
                  <div class="card mt-4 maintenance-box">
                    <div class="card-body">
                      <i class="bx bx-block mb-4 h1 text-primary"></i>
                      <h5 class="font-size-15 text-uppercase">
                        Recusar Material
                      </h5>
                      <p class="text-muted mb-0">
                        Não estou de acordo com algum ponto apresentado no material.
                      </p>
                    </div>
                  </div>
                </div>


                <div class="col-md-4">
                  <div class="card mt-4 maintenance-box">
                    <div class="card-body">
                      <i class="bx bxl-whatsapp mb-4 h1 text-primary"></i>
                      <h5 class="font-size-15 text-uppercase">
                        Precisa de Suporte?
                      </h5>
                      <p class="text-muted mb-0">
                        Se precisa falar com o responsável pelo projeto clique aqui.

                      </p>
                    </div>
                  </div>
                </div>


                <div class="col-md-4">
                  <div class="card mt-4 maintenance-box">
                    <div class="card-body">
                      <i class="bx bx-check-double mb-4 h1 text-primary"></i>
                      <h5 class="font-size-15 text-uppercase">
                        Estou de Acordo
                      </h5>
                      <p class="text-muted mb-0">
                        Estou de acordo com todo o material apresentado.
                      </p>
                    </div>
                  </div>
                </div>


              </b-row>

            </div>
          </div>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
